import { arrowDownOutline, arrowUpOutline } from "ionicons/icons";
import { FC } from "react";
import { Icon } from "../icon";

export const SortArrow: FC<{ isUp: boolean }> = ({ isUp }) => {
  return <Icon icon={isUp ? arrowUpOutline : arrowDownOutline} />;
};
